// extracted by mini-css-extract-plugin
module.exports = {"h1":"Specs_h1__Ob7Ev","specs_div":"Specs_specs_div__QR5Yi","filter_btn":"Specs_filter_btn__v6M6S"};